// import React from "react";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useRef } from "react";
// // const bcrypt = require('bcrypt');

// const saltRounds = 10;
// let jay = 0;
// let isValid = false;
// const ConfirmPassword = (props) => {
//   const newPassRef = useRef();
//   const confirmPassRef = useRef();
//   const [isCall, setIsCall] = useState();
//   const [isResponse, setIsResponse] = useState();
//   const [isError, setIsError] = useState();

//   useEffect(() => {
//     function myFunc() {
//       var myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/json");

//       var raw = JSON.stringify({
//         emailID: props.email,
//         otpNumber: "",
//         isOtpVerified: "1",
//         newPassword: newPassRef.current.value,
//         confirmPassword: confirmPassRef.current.value
//       })

//       var requestOptions = {
//         method: 'POST',
//         headers: myHeaders,
//         body: raw,
//         redirect: 'follow'
//       };

//       fetch("/SetNewPassword", requestOptions)
//         .then(response => response.text())
//         .then(result => JSON.parse(result).Message === "Success" ? setIsResponse("success") : setIsResponse("fail"))
//         .catch(error => setIsResponse("fail"));
//     }
//     if (jay > 1)
//       myFunc();
//     jay++;
//   }, [isCall]);

//   const passwordChangedHandler = (e) => {
//     e.preventDefault();
//     if (newPassRef.current.value !== confirmPassRef.current.value || !newPassRef.current.value) {
//       isValid = false;
//       setIsError("Password does not match");
//     }
//     else if (newPassRef.current.value.length < 8) {
//       isValid = false;
//       setIsError("Password must be of length 8");
//     }
//     else isValid = true;
//     if (isValid)
//       setIsCall(prev => !prev);
//   }

//   if (isResponse === "success") {
//     props.forgotPassword(false);
//   }

//   return (
//     <div id="form">
//       {isResponse === "fail" && <p style={{color: "red"}}>Some error occured, please try again later!</p>}
//       {isError && <p style={{color: "red"}}>{isError}</p>}
//       <input type="password" placeholder="Enter New Password" ref={newPassRef} id="input" />
//       <input type="password" placeholder="Confirm New Password" ref={confirmPassRef} id="input" />
//       <input
//         type="submit"
//         value="Go to Login Page"
//         id="loginButton"
//         onClick={passwordChangedHandler}
//       />
//     </div>
//   );
// };

// export default ConfirmPassword;

// //git push origin HEAD:refs/heads/<origin>

import React, { useRef, useState } from "react";
import useHttp from "../../Hooks/use-http";
import { useHistory } from "react-router-dom";

const ConfirmPassword = (props) => {
  const newPassRef = useRef();
  const confirmPassRef = useRef();
  const [isError, setIsError] = useState("");
  const { sendRequest } = useHttp();
  const history = useHistory();

  const passwordChangedHandler = async (e) => {
    e.preventDefault();
    const newPassword = newPassRef?.current?.value;
    const confirmPassword = confirmPassRef?.current?.value;

    if (!newPassword || newPassword !== confirmPassword) {
      setIsError("Passwords do not match");
      return;
    }
    if (newPassword.length < 4) {
      setIsError("Password must be at least 8 characters long");
      return;
    }

    // try {
    //   const response = await fetch("http://localhost:4001/setNewPassword", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({ email: props.email, newPassword }),
    //   });
    //   console.log("🚀 ~ passwordChangedHandler ~ response: 4545", response);

    //   const data = await response.json();
    //   console.log("🚀 ~ passwordChangedHandler ~ data: 4545", data);
    //   if (data.success) {
    //     props.forgotPassword(false);
    //   } else {
    //     setIsError("Failed to update password");
    //   }
    // } catch (error) {
    //   setIsError("Error updating password", error);
    // }

    sendRequest(
      {
        url: "/setNewPassword",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: props.email,
          newPassword,
        },
      },
      (response) => {
        if (response.Message === "Success") {
          alert("Change Password Successfully");
          history.push("/");
          return;
        } else {
          alert("Something went wrong");
        }
      }
    );
  };

  return (
    <div id="form">
      {isError && <p style={{ color: "red" }}>{isError}</p>}
      <input
        type="password"
        placeholder="Enter New Password"
        ref={newPassRef}
        id="input"
      />
      <input
        type="password"
        placeholder="Confirm New Password"
        ref={confirmPassRef}
        id="input"
      />
      <input
        type="submit"
        value="Update Password"
        id="loginButton"
        onClick={passwordChangedHandler}
      />
    </div>
  );
};

export default ConfirmPassword;
